import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useOrderBump } from './OrderBumpContext';
import { trackInitiateCheckout } from '../utils/hotmartTracking';
const URL_WITH_PACKAGING = 'https://pay.hotmart.com/M104730533B?off=5yzcnkdd&checkoutMode=10';
const URL_WITHOUT_PACKAGING = 'https://pay.hotmart.com/M104730533B?off=mu3aqqgj&checkoutMode=10';
export function PaymentPopup() {
  const {
    showPopup,
    setShowPopup
  } = useOrderBump();
  return <AnimatePresence data-id="element-347">
      {showPopup && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={() => setShowPopup(false)} data-id="element-348">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-349" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative bg-white rounded-3xl shadow-2xl max-w-lg w-full p-8 md:p-10 border border-brand-gold/20" data-id="element-350">
            {/* Close button */}
            <button onClick={() => setShowPopup(false)} className="absolute top-4 right-4 text-brand-brown/40 hover:text-brand-brown transition-colors text-2xl leading-none" data-id="element-351">
              ✕
            </button>

            {/* Content */}
            <div className="text-center mb-6" data-id="element-352">
              <span className="text-4xl mb-4 block" data-id="element-353">📦</span>
              <h3 className="text-2xl md:text-3xl font-bold text-brand-brown mb-4" data-id="element-354">
                ¡Esperá! ¿Querés continuar sin esto?
              </h3>
              <p className="text-brand-brown/70 text-base md:text-lg leading-relaxed" data-id="element-355">
                💰 Aprendé a empacar tus milhojas como una marca de lujo: 10
                diseños exclusivos, materiales baratos con look premium y la
                guía exacta para que tus clientes paguen{' '}
                <span className="font-bold text-brand-brown" data-id="element-356">3 veces más</span>{' '}
                solo por la presentación.
              </p>
              <p className="text-brand-brown font-bold text-xl mt-3" data-id="element-357">
                Sumalo por solo{' '}
                <span className="text-brand-orange" data-id="element-358">$6.000</span>
              </p>
            </div>

            {/* Buttons */}
            <div className="space-y-3" data-id="element-359">
              <a href={URL_WITH_PACKAGING} target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className="block w-full py-4 px-6 bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-center text-lg rounded-xl shadow-[0_6px_20px_rgba(212,114,42,0.3)] hover:shadow-[0_8px_25px_rgba(212,114,42,0.4)] transition-all duration-300" data-id="element-360">
                Sí, quiero sumarle también el Packaging Luxury
              </a>
              <a href={URL_WITHOUT_PACKAGING} target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className="block w-full py-3 px-6 bg-gray-100 hover:bg-gray-200 text-brand-brown/60 font-medium text-center text-sm rounded-xl transition-all duration-300" data-id="element-361">
                No gracias, solo quiero la receta con los bonos
              </a>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}